import {
  disableBodyScroll,
  enableBodyScroll,
  clearAllBodyScrollLocks,
} from 'body-scroll-lock-upgrade';

import { gsap } from "gsap";

function initSearchForm(){
  
  const search_button = document.querySelector('.search-form__button')
  const search_veil = document.querySelector('.search-form__veil')
  const search_close = document.querySelector('.search-form__close')
  const search_modal = document.querySelector('.search-form__modal')
  
  if(search_button && search_veil){
    search_button.addEventListener('click', () => {
      gsap.to(search_veil, {display: 'block', opacity: 1, duration: 0.5})
      if(search_modal){
        disableBodyScroll(search_modal);
      }
    })
  }
  
  if(search_close && search_veil){
    search_close.addEventListener('click', () => {
      gsap.to(search_veil, {opacity: 0, duration: 0.5, onComplete: function(){
        search_veil.style.display = 'none'
      }})
      if(search_modal){
        enableBodyScroll(search_modal);
      }
    })
  }
  
  if(search_veil){
    search_veil.addEventListener('click', (e) => {
      if(e.target !== search_veil && e.target !== document.querySelector('.search-form__placer')) return;
      
      gsap.to(search_veil, {opacity: 0, duration: 0.5, onComplete: function(){
        search_veil.style.display = 'none'
      }})
      if(search_modal){
        enableBodyScroll(search_modal);
      }
    })
  }
}

export default initSearchForm;